/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { SearchXIcon } from "lucide-react"
import { observer } from "mobx-react-lite"
import { useParams } from "react-router"

import { ApplicationSearchViewmodel } from "../../features/application-search/application-search-viewmodel"
import { useViewModel } from "../app/app-hooks"
import { ApplicationListItem } from "../application/application-list-item"
import { ApplicationSearch } from "../components/application-search"
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from "../primitives/empty"

import styles from "./application-search-view.module.css"

export const ApplicationResultView = observer(() => {
    const { query = "" } = useParams<{ query: string }>()
    const vm = useViewModel(ApplicationSearchViewmodel)
    const results = vm.searchResults(query)

    return (
        <div className="w-content max-inline-[2400px]">
            <header className="mb-6 flex flex-wrap items-center justify-between gap-y-4">
                <h1 className="m-0 text-3xl font-bold text-primary">Application search</h1>
                <ApplicationSearch />
            </header>

            {results.length === 0 && (
                <Empty className="border bg-background">
                    <EmptyHeader>
                        <EmptyMedia>
                            <SearchXIcon />
                        </EmptyMedia>
                        <EmptyTitle>No results found</EmptyTitle>
                        <EmptyDescription>
                            Nothing matches <span className="font-semibold text-foreground">{query}</span>.
                        </EmptyDescription>
                    </EmptyHeader>
                </Empty>
            )}

            {results.length > 0 && (
                <div className={styles.list}>
                    {results.map((detail) => (
                        <ApplicationListItem key={detail.avUserId} item={detail} />
                    ))}
                </div>
            )}
        </div>
    )
})
